import { Alert, Button, Col, Divider, Form, Row } from "antd";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import useMazakaForm from "hooks/useMazakaForm";
import ResultFilter from "./ResultFilter";
import { useState } from "react";
import CountryAdressDetails from "apps/Common/Adress/CountryAddressDetails";
import { getMLSStoreFilter } from "../MLSPortFolio/Services";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";


const AddOrUpdateMLS = () => {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const { formActions, mazakaForm } = useMazakaForm(form, {
    submitText: "Filtrele",
  });
  const [addresNamesInfo, setAddresInfoe] = useState<any>({});
  const [storeList, setStoreList] = useState([]);
  const handleOnFinish = async () => {
    // mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    for (let key in formValues) {
      if (
        !formValues[key] ||
        (Array.isArray(formValues[key]) && formValues[key].length === 0)
      ) {
        delete formValues[key];
      }
    }
    if (formValues?.date) {
      const endDate = dayjs().format("YYYY-MM-DD"); // Bugünün tarihi
      let startDate = "";
      if (formValues?.date === "1") {
        startDate = dayjs().subtract(1, "month").format("YYYY-MM-DD");
      } else if (formValues?.date === "3") {
        startDate = dayjs().subtract(3, "month").format("YYYY-MM-DD");
      } else if (formValues?.date === "6") {
        startDate = dayjs().subtract(6, "month").format("YYYY-MM-DD");
      }
      formValues["StartDate"] = startDate;
      formValues["EndDate"] = endDate;
      delete formValues["date"];
    }

    formValues["CityIds"] = [formValues["cityId"]];
    formValues["DistrictIds"] = formValues["districtIds"];
    formValues["IncludeProperties"] = ["District","City",]
    formValues["AdvertId"] = advertId;
    delete formValues["cityId"];
    delete formValues["districtIds"];

    try {
      const response = await getMLSStoreFilter(formValues);
      if (response?.data?.data) {
        setStoreList(response.data.data);
      }
      mazakaForm.setSuccess(2000, () => "İşlem Başarıı");
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
      console.log("somethins wrong during filtering store", error);
    }
  };

  const dateOptions = [
    {
      label: "Son 1 Ay",
      value: "1",
    },
    {
      label: "Son 3 Ay",
      value: "3",
    },
    {
      label: "Son 6 Ay",
      value: "6",
    },
  ];
  const adCountOptions = [
    { label: "Hepsi", value: 1 },
    { label: "5 'den Fazla", value: 5 },
    { label: "10 'den Fazla", value: 10 },
    { label: "15 'den Fazla", value: 15 },
    { label: "20 'den Fazla", value: 20 },
    { label: "25 'den Fazla", value: 25 },
    { label: "30 'den Fazla", value: 30 },
  ];

  const successfullySoldValueOptions = [
    { label: "5 Milyon 'dan Fazla", value: 5000000 },
    { label: "10 Milyon 'dan Fazla", value: 10000000 },
    { label: "20 Milyon 'dan Fazla", value: 20000000 },
    { label: "30 Milyon 'dan Fazla", value: 30000000 },
    { label: "40 Milyon 'dan Fazla", value: 40000000 },
    { label: "50 Milyon 'dan Fazla", value: 50000000 },
    { label: "60 Milyon 'dan Fazla", value: 60000000 },
    { label: "70 Milyon 'dan Fazla", value: 70000000 },
    { label: "80 Milyon 'dan Fazla", value: 80000000 },
    { label: "90 Milyon 'dan Fazla", value: 90000000 },
    { label: "100 Milyon 'dan Fazla", value: 100000000 },
  ];



  return (
    <Col xs={24}>
      <Row>
        <Col xs={24}>
          <MazakaForm
            form={form}
            onFinish={handleOnFinish}
            submitButtonVisible={false}
            {...formActions}
          >
            <Row gutter={[20, 20]}>
              <CountryAdressDetails
                selectInputType="inline"
                addresNamesInfo={addresNamesInfo}
                setAddresNamesInfo={setAddresInfoe}
                multipleFields={{
                  country: undefined,
                  stateProvince: "multiple",
                  district: "multiple",
                  city: undefined,
                }}
                viewingFields={{
                  country: false,
                  stateProvince: true,
                  district: true,
                  city: false,
                }}
                fieldsRequiredRules={{
                  country: false,
                  stateProvince: true,
                  district: true,
                  city: false,
                }}
                form={form}
                allowClear={true}
              />

              <Col xs={24}>
                <Row gutter={[20, 0]} className="!mt-2">
                  <Col xs={24} className="">
                    <Alert
                      className="!p-4"
                      message="İlgili firmalar aşağıdaki kriterlerde seçeceğiniz tarih aralığındaki ilan sayısı ve değerinde ilanı bulunan satıcıların filtrelenmesini sağlar."
                      type="info"
                      showIcon
                      closable
                    />
                  </Col>
                  <MazakaSelect
                    label="Tarih Seç"
                    placeholder="Tarih Seç"
                    xs={24}
                    name={"date"}
                    md={12}
                    lg={8}
                    options={dateOptions}
                    allowClear
                  />

                  <MazakaSelect
                    label="İlan Sayısı "
                    placeholder="İlan Sayısı "
                    name="AdvertCount"
                    xs={24}
                    md={12}
                    lg={8}
                    options={adCountOptions}
                    allowClear
                  />

                  <MazakaSelect
                    label="Başarılı Olarak Satış Yapılan Değeri "
                    placeholder="Başarılı Olarak Satış Yapılan Değeri"
                    xs={24}
                    md={12}
                    lg={8}
                    allowClear
                    options={successfullySoldValueOptions}
                    name={"TotalSalesAmount"}
                  />
                </Row>
              </Col>

              <Col xs={24}>
                <Button
                  htmlType="submit"
                  size="large"
                  className="!text-base !bg-[#FFC502] !text-black !px-6"
                >
                  Filtrele
                </Button>
              </Col>
            </Row>
          </MazakaForm>
        </Col>
       
        <Col xs={24}>
          <Divider />
        </Col>
        <Col xs={24}>
          <ResultFilter storeList={storeList} setStoreList={setStoreList} />
        </Col>
      </Row>
    </Col>
  );
};

export default AddOrUpdateMLS;
